import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>&copy; <a href='https://github.com/gregolive' target='_blank' rel='noreferrer'>gregolive</a></p>
    </footer>
  );
};

export default Footer;
